import _Card from "@mui/material/Card";
import _CardActions from "@mui/material/CardActions";
import _CardContent from "@mui/material/CardContent";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { facilityDistributionColors } from '../hooks';
import { RoadTypeBar } from './road-type-bar';
import { RoadTypeLegend } from './road-type-legend';
export const facilities = [{
  key: 'recommendedRoads',
  color: facilityDistributionColors.recommended,
  labelKey: 'commons.facilities_legend.dedicated_roads',
  descriptionKey: 'commons.facilities_legend.dedicated_roads_description'
}, {
  key: 'normalRoads',
  color: facilityDistributionColors.normal,
  labelKey: 'commons.facilities_legend.shared_roads',
  descriptionKey: 'commons.facilities_legend.shared_roads_description'
}, {
  key: 'discouragedRoads',
  color: facilityDistributionColors.discouraged,
  labelKey: 'commons.facilities_legend.other_routes',
  descriptionKey: 'commons.facilities_legend.other_roads_description'
}];
export function FacilitiesCard({
  size,
  layout,
  route,
  actions,
  ...props
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Card, _extends({}, props, {
    sx: {
      ...props.sx,
      borderRadius: 4,
      width: layout === 'row' ? 'calc((100% - 16px) / 2)' : '100%'
    },
    variant: "outlined"
  }), /*#__PURE__*/React.createElement(_CardContent, {
    sx: {
      '&&': {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 2
      }
    }
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: size === 'small' ? '1rem' : '1.1rem',
    fontWeight: 600
  }, route ? t('commons.routing.distances.cycling_roads', {
    value: route.recommendedRoadsPercentage
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 150
  })), /*#__PURE__*/React.createElement(RoadTypeBar, {
    entries: facilities,
    values: route ? [route.recommendedRoadsPercentage, route.normalRoadsPercentage, route.discouragedRoadsRoadsPercentage] : undefined
  }), /*#__PURE__*/React.createElement(RoadTypeLegend, {
    entries: facilities
  })), actions && /*#__PURE__*/React.createElement(_CardActions, null, actions));
}